import { FC, PropsWithChildren } from 'react';
import { Router } from 'react-location';
import routes from './routes';
import location from './location';
import filterRoutes from './filter';
import { getBasePath } from 'utils/subdomain';

const RoutesProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Router
      location={location}
      routes={routes}
      filterRoutes={filterRoutes()}
      basepath={getBasePath()}
    >
      {children}
    </Router>
  );
};

export default RoutesProvider;
